import { render } from "./EmployeeTimeReport.vue?vue&type=template&id=5ec95ae3&scoped=true"
import script from "./EmployeeTimeReport.vue?vue&type=script&lang=js"
export * from "./EmployeeTimeReport.vue?vue&type=script&lang=js"

import "./time-reports.scss?vue&type=style&index=0&id=5ec95ae3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec95ae3"]])

export default __exports__